import { useAppSelector } from 'common/hooks/redux'

import { IntakeReleaseGate } from './intake-release-gate'
import { useIntakeLock } from './use-intake-lock'

export const IntakeLockGate = () => {
  const locked = useIntakeLock()
  const isIntakeBlocking = useAppSelector((state) => state.procedureReducer.isIntakeBlocking)

  if (!locked || isIntakeBlocking) return null

  return <IntakeReleaseGate />
}
